<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-header-2">
                                <h5>Category Information</h5>
                            </div>
                            <v-form class="theme-form theme-form-2 mega-form" ref="form">
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Category</label>
                                        <div class="col-sm-10" >
                                                <v-treeview style="max-height:33rem;" class="border"
                                                    :items="treeCategoryData"
                                                    :item-title="(item) => `${getMultilangText(item.name)} (ID: ${item.id})`"
                                                    item-value="id"
                                                    v-model:activated="selectedTreeCategoryData"
                                                    @update:active="getActiveCategoryValue"
                                                    :open="openedCategoryFather"
                                                    activatable
                                                    open-all
                                                ></v-treeview>
                                                <br></br>
                                                <label class="form-label-title col-sm-10 mb-0">
                                                    Current Category: {{ getSelectedCategoryParents() }}
                                                </label>
                                        </div>
                                                                        
                                    </div>
                                </div>
                                <!-- Nombre multi-idioma {es,en,fr}: ES obligatorio, EN/FR opcionales
                                     (la tienda cae a ES si falta la traducción) -->
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Nombre (ES)</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Nombre en español" v-model="name.es" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Nombre (EN)</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Name in English" v-model="name.en"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Nombre (FR)</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Nom en français" v-model="name.fr"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <!-- Descripción SEO multi-idioma: la tienda la renderiza como texto de la
                                     landing de categoría (templateShop). Campos opcionales. -->
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Descripción SEO (ES)</label>
                                        <div class="col-sm-10">
                                            <v-textarea rows="3" auto-grow placeholder="Texto SEO de la categoría en español (se muestra en la página de la tienda)" v-model="description.es"></v-textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Descripción SEO (EN)</label>
                                        <div class="col-sm-10">
                                            <v-textarea rows="3" auto-grow placeholder="Category SEO text in English" v-model="description.en"></v-textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Descripción SEO (FR)</label>
                                        <div class="col-sm-10">
                                            <v-textarea rows="3" auto-grow placeholder="Texte SEO de la catégorie en français" v-model="description.fr"></v-textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">ID Category father</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Category father" v-model="category_father"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                
                                
                                <div class="d-flex flex-column">
                                    <v-btn class="mt-4" color="success" block @click="validate"> Update </v-btn>
                                </div>
                            </v-form>
                        </div>

                        <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import { getMultilangText } from '@/services/multilangText'

export default {
    name: 'app',
    title: 'Edit category',

    data() {
        return {
            cargado:false,
            id: null,
            name: { es: '', en: '', fr: '' },
            description: { es: '', en: '', fr: '' },
            category_father: '',

            // Categoria
            selectedTreeCategoryData  : [], 
            treeCategoryData : [],   
            openedCategoryFather: [0,1],

            messageError: '',
            typeOfMessage: ''
        }
    },
    methods: {
        getMultilangText,
        async validate() {
            const { valid } = await this.$refs.form.validate()

            if (valid) {
                this.update()
            } else {
                alert('Faltan parametros')
            }
        },
        resetValidation() {
            this.$refs.form.resetValidation()
        },
        getListCategory() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/category/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        
                        self.treeCategoryData = this.buildTreeCategory(response.data);
                       
                        this.openedCategoryFather = [0,1]
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        buildTreeCategory(categories, parentId = null) {
            const tree = [];
            categories.filter(category => category.categoryFather === parentId).forEach(category => {
                const children = this.buildTreeCategory(categories, category.id);
                if (children.length) {
                    category.children = children;
                }
                tree.push(category);
                //this.toggleCategory(category)
            });
            
            return tree;
        }, 
        getActiveCategoryValue(value){
            this.selectedTreeCategoryData = value
            this.getSelectedCategoryParents()
        }, 
        getSelectedCategoryParents() {
            if (this.treeCategoryData && this.selectedTreeCategoryData.length > 0) {
                const selectedCategoryId = this.selectedTreeCategoryData[0];

                // Función recursiva para buscar una categoría por su ID
                const findCategoryById = (categories, id) => {
                for (let category of categories) {
                    if (category.id === id) {
                    return category;
                    }
                    if (category.children && category.children.length > 0) {
                    const result = findCategoryById(category.children, id);
                    if (result) {
                        return result;
                    }
                    }
                }
                return null;
                };

                // Función para encontrar todos los padres de una categoría
                const findParents = (categories, id) => {
                let category = findCategoryById(categories, id);
                if (!category) {
                    return [];
                }

                const parents = [];

                while (category && category.categoryFather !== null) {
                    category = findCategoryById(categories, category.categoryFather);
                    if (category) {
                    parents.unshift(category);
                    }
                }

                return parents;
                };

                // Obtener los padres de la categoría seleccionada
                const parents = findParents(this.treeCategoryData, selectedCategoryId);

                // Buscar la categoría seleccionada para obtener su nombre
                const selectedCategory = findCategoryById(this.treeCategoryData, selectedCategoryId);

                // Concatenar los nombres de los padres y el nombre de la categoría seleccionada
                if (selectedCategory) {
                    const hierarchy = [...parents.map(parent => getMultilangText(parent.name)), getMultilangText(selectedCategory.name)].join(' > ');
                    return hierarchy;
                } else {
                    return "N/A";
                }
            }
            return "N/A";
        },
        getCategory() {
            let self = this

            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/category/details_id/' + this.id
            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {

                        // name/description son JSON {es,en,fr}; los registros antiguos pueden traer string plano o null
                        const rawName = response.data.name
                        if (rawName && typeof rawName === 'object') {
                            self.name = { es: rawName.es || '', en: rawName.en || '', fr: rawName.fr || '' }
                        } else {
                            self.name = { es: rawName || '', en: '', fr: '' }
                        }
                        const rawDescription = response.data.description
                        if (rawDescription && typeof rawDescription === 'object') {
                            self.description = { es: rawDescription.es || '', en: rawDescription.en || '', fr: rawDescription.fr || '' }
                        } else {
                            self.description = { es: rawDescription || '', en: '', fr: '' }
                        }
                        self.category_father = response.data.categoryFather

                        if(response.data.id ){
                            self.getActiveCategoryValue([response.data.id] )
                        }
                        
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        update() {
            // Enviar solo los idiomas con texto (name.es es obligatorio en el form);
            // el backend guarda description NULL si no queda ningún idioma
            const name = {}
            const description = {}
            for (const lang of ['es', 'en', 'fr']) {
                if (this.name[lang] && this.name[lang].trim() !== '') {
                    name[lang] = this.name[lang].trim()
                }
                if (this.description[lang] && this.description[lang].trim() !== '') {
                    description[lang] = this.description[lang].trim()
                }
            }

            let newObject = {
                id: this.id,
                name,
                description,
                category_father: this.category_father,
            }

            axios.post('http://localhost:8001/admin/category/update', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            }).then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                this.getListCategory()
                this.getCategory()
                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El registro no se ha modificado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
            });
        }
    },
    async created() {
        this.id = this.$route.params.id
        await this.getListCategory()
        await this.getCategory()
        this.cargado=true
    }
}
</script>

<style></style>
